import { render, staticRenderFns } from "./tabNotifications.vue?vue&type=template&id=0fa399bc&scoped=true"
import script from "./tabNotifications.vue?vue&type=script&lang=js"
export * from "./tabNotifications.vue?vue&type=script&lang=js"
import style0 from "./tabNotifications.vue?vue&type=style&index=0&id=0fa399bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa399bc",
  null
  
)

export default component.exports